export const INTEGER: string = 'Integer'
